export const Steps = [
    {
        target: '#query-title',
        content: 'Enter a title for your query.',
    },
    {
        target: '#query-tags',
        content: 'Tags are like categories that your query could fit into.',
    },
    {
        target: '#query-description',
        content: 'Try to make description clear for yourself and others.',
    },
    {
        target: '#continue-button',
        content: 'Click this button to continue onto the next page.',
    },
]